export default __webpack_public_path__ + "static/media/icon_connext.40810325.svg";